import { Icons } from 'bold-ui'
import {
  HorarioAgendaSelectFieldModel,
  LocalAtendimentoSelectFieldModel,
  LotacaoAgendaSelectFieldModel,
} from 'components/form'

export enum ProximaConsultaTypeEnum {
  PRE_NATAL,
  ODONTOLOGICO,
}

export interface SugestaoProximaConsultaModel {
  type: ProximaConsultaTypeEnum
  date: LocalDate
}

export const agendamentoPropsRecord: Record<ProximaConsultaTypeEnum, { icon: Icons; description: string }> = {
  [ProximaConsultaTypeEnum.PRE_NATAL]: { icon: 'pregnant', description: 'Acompanhamento pré-natal' },
  [ProximaConsultaTypeEnum.ODONTOLOGICO]: { icon: 'calendarFilled', description: 'Consulta odontológica pré-natal' },
}

export interface AgendarConsultaSectionModel {
  lotacao?: LotacaoAgendaSelectFieldModel
  data?: LocalDate
  horario?: HorarioAgendaSelectFieldModel
  isForaUbs?: boolean
  localAtendimento?: LocalAtendimentoSelectFieldModel
  observacoes?: string
}

export interface AgendarProximasConsultasSectionModel {
  proximaConsultaPreNatal?: AgendarConsultaSectionModel
  proximaConsultaOdontologica?: AgendarConsultaSectionModel
}

export interface ComprovanteAgendamentoSectionModel {
  enviarParaCidadao: boolean
  emailCidadao: string | null
  imprimir: boolean
}
